import React from 'react'
import { useLocation } from 'react-router-dom'

import { generateCompanyURI } from 'sagas/helpers/generateCompanyURI'

import { LocationBasedContentProps } from './LocationBasedContent.types'

export const LocationBasedContent = ({ allowedPaths, children }: LocationBasedContentProps) => {
    const location = useLocation()

    const isContentVisible = allowedPaths.some((path) => location.pathname.includes(generateCompanyURI(path)))

    if (!isContentVisible) {
        return <></>
    }

    return <>{children}</>
}
